import { SpecSheetTab } from "@specsheet-common/shared-types";
import { notNullish } from "../typescript";

/**
 * When editing a column from a channel tab, keep it visible on that tab so a
 * permission-only save cannot hide it.
 */
export const keepColumnVisibleOnTab = (
  isHiddenByTab: Partial<Record<SpecSheetTab, boolean>> | undefined,
  currentTab: SpecSheetTab | undefined
): Partial<Record<SpecSheetTab, boolean>> | undefined => {
  if (!notNullish(currentTab)) {
    return isHiddenByTab;
  }

  return {
    ...(isHiddenByTab ?? {}),
    [currentTab]: false,
  };
};

/**
 * Prefer explicit update values; otherwise keep the existing tab layout fields.
 */
export const preserveColumnTabLayoutFields = <
  T extends {
    isHiddenByTab?: Partial<Record<SpecSheetTab, boolean>>;
    positionByTab?: Partial<Record<SpecSheetTab, number>>;
  }
>(
  existing: T,
  update: T
): Pick<T, "isHiddenByTab" | "positionByTab"> => ({
  isHiddenByTab:
    update.isHiddenByTab !== undefined
      ? update.isHiddenByTab
      : existing.isHiddenByTab,
  positionByTab:
    update.positionByTab !== undefined
      ? update.positionByTab
      : existing.positionByTab,
});
